import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="px-4 md:px-10 py-16 md:py-20">
        {/* Brand */}
        <div className="mb-12">
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold tracking-tight">
            SUPERBUYSPREAD
          </h2>
        </div>

        {/* Three columns */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-16">
          {/* Left: About */}
          <div>
            <p className="text-sm leading-relaxed text-foreground-200 max-w-xs">
              SuperbuySpread.fit is an independent educational platform helping users discover, understand, and make informed product research decisions. We are not affiliated with any official brand.
            </p>
            <div className="flex items-center gap-4 mt-8">
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center cursor-pointer hover:border-foreground-200 transition-colors">
                <i className="ri-twitter-x-line text-foreground-200 text-sm"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center cursor-pointer hover:border-foreground-200 transition-colors">
                <i className="ri-instagram-line text-foreground-200 text-sm"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center cursor-pointer hover:border-foreground-200 transition-colors">
                <i className="ri-pinterest-line text-foreground-200 text-sm"></i>
              </a>
              <a href="#" className="w-10 h-10 rounded-full border border-foreground-500/40 flex items-center justify-center cursor-pointer hover:border-foreground-200 transition-colors">
                <i className="ri-youtube-line text-foreground-200 text-sm"></i>
              </a>
            </div>
          </div>

          {/* Middle: Quick Links */}
          <div className="space-y-8">
            <div>
              <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">Quick Links</p>
              <div className="space-y-2">
                <a href="/" className="block text-sm text-foreground-200 hover:text-background-50 transition-colors cursor-pointer">Home</a>
                <Link to="/superbuy-spreadsheet-complete-guide" className="block text-sm text-foreground-200 hover:text-background-50 transition-colors cursor-pointer">Complete Guide</Link>
                <Link to="/superbuy-spreadsheet-safety-guide" className="block text-sm text-foreground-200 hover:text-background-50 transition-colors cursor-pointer">Safety Guide</Link>
                <Link to="/superbuy-spreadsheet-beginner-tutorial" className="block text-sm text-foreground-200 hover:text-background-50 transition-colors cursor-pointer">Beginner Tutorial</Link>
                <a href="#categories" className="block text-sm text-foreground-200 hover:text-background-50 transition-colors cursor-pointer">Categories</a>
                <a href="#faq" className="block text-sm text-foreground-200 hover:text-background-50 transition-colors cursor-pointer">FAQ</a>
              </div>
            </div>
          </div>

          {/* Right: Disclaimer */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-3">Disclaimer</p>
            <p className="text-sm leading-relaxed text-foreground-300">
              This website provides independent educational information. Users should independently verify product information before making purchases. All external links open in new tabs.
            </p>
            <div className="mt-6">
              <img
                src="https://readdy.ai/api/search-image?query=Soft%20warm%20lifestyle%20flat%20lay%20composition%20with%20natural%20linen%20texture%20fabric%2C%20dried%20flowers%20and%20subtle%20accessories%2C%20gentle%20morning%20light%20from%20window%2C%20calm%20modern%20aesthetic%2C%20cream%20and%20sage%20green%20tones%2C%20editorial%20style%20with%20organic%20elements%2C%20clean%20minimal%20beauty&width=400&height=300&seq=footer-img-refresh-04&orientation=landscape"
                alt="Superbuy Spreadsheet aesthetic lifestyle"
                title="Superbuy Spreadsheet lifestyle inspiration"
                className="w-full max-w-[200px] h-auto rounded-xl"
              />
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-14 pt-8 border-t border-foreground-800/30 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} SuperbuySpread.fit. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">Terms</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-foreground-200 transition-colors cursor-pointer">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
}